import React, { Component } from 'react';

import { compose } from 'recompose';

import { withAuthorization } from '../../components/Session';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
// import Avatar from '@material-ui/core/Avatar';
// import Utilities from '../../utils/utilities'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
// import * as ROUTES from '../../constants/routes';
import * as ROLES from '../../constants/roles';
// import { Link as RouterLink } from 'react-router-dom';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';

import { StyledTable, StyledTableHead, StyledTableCell, StyledTableRow } from '../../components/Table';

// import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
// import TableCell from '@material-ui/core/TableCell';
// import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Utilities from '../../utils/utilities';

import Spinner from '../../components/Spinner';
import { openConfirmDialog } from '../../components/Dialog';
import { openSnackbar } from '../../components/Notifier';

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexWrap: 'wrap',
    padding: '12px',
    marginTop: theme.spacing(5),
  },
  marginRight: {
    marginRight: theme.spacing(1),
  },
  tableWrapper: {
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
  },
  moreButton: {
    color: theme.palette.primary.main,
    minWidth: 'unset',
    padding: theme.spacing(1),
  },
  editMenu: {
    color: theme.palette.primary.main,
  },
  deleteMenu: {
    color: theme.palette.error.main,
  },
  outlineButton: {
    borderRadius: '100px',
    marginTop: theme.spacing(1),
  },
  spacer: {
    flex: 'unset',
  },
  avatar: {
    maxWidth: 100,
    maxHeight: 100,
  },
});

const StatBadge = withStyles((theme) => ({
  badge: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
}))((props) => {
  let { stat, classes } = props;
  return (
    <Tooltip placement="top" arrow title={stat._id}>
      <Chip className={classes.badge} label={stat.count} variant="outlined" />
    </Tooltip>
  );
});

class FreightForwardersTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      openMenuRowId: null,
    };
  }

  openMenu = (row) => (event) => {
    // https://medium.freecodecamp.org/reactjs-pass-parameters-to-event-handlers-ca1f5c422b9
    this.setState({
      anchorEl: event.currentTarget,
      openMenuRowId: row._id,
    });
  };

  closeMenu = () => {
    this.setState({ openMenuRowId: null });
  };

  render() {
    const { classes, freightForwarders, totalItems, itemsPerPage, currentPage, onPageChange } = this.props;
    const { anchorEl } = this.state;

    return (
      <div className={classes.tableWrapper}>
        <StyledTable className={classes.table} size="small">
          <StyledTableHead className={classes.tableHead}>
            <TableRow>
              <StyledTableCell>Id</StyledTableCell>
              <StyledTableCell width={80}>Name</StyledTableCell>
              <StyledTableCell>Logo</StyledTableCell>
              <StyledTableCell width={150}>Url</StyledTableCell>
              <StyledTableCell width={200}>Address</StyledTableCell>
              <StyledTableCell width={100}>Phone Number</StyledTableCell>
              <StyledTableCell width={150}>Quotes</StyledTableCell>
              <StyledTableCell width={100}>Ratesheets</StyledTableCell>
              <StyledTableCell>Actions</StyledTableCell>
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {freightForwarders.map((row) => (
              <StyledTableRow key={row._id} className={classes.tableRow}>
                <StyledTableCell>{row._id}</StyledTableCell>
                <StyledTableCell>{row.name}</StyledTableCell>
                <StyledTableCell>
                  <img alt={row.name} src={Utilities.getPhotoUrl(row.logo_images, 'logo')} className={classes.avatar} />
                </StyledTableCell>
                <StyledTableCell>{row.url}</StyledTableCell>
                <StyledTableCell>
                  {[row.address, row.suburb, row.city, row.country].filter((o) => o).join(', ')}
                </StyledTableCell>
                <StyledTableCell>{row.phone_number}</StyledTableCell>
                <StyledTableCell>
                  {row.quoteStats.map((stat) => {
                    return <StatBadge key={stat._id} stat={stat} />;
                  })}
                </StyledTableCell>
                <StyledTableCell>
                  {row.ratesheetStats.map((stat) => {
                    return <StatBadge key={stat._id} stat={stat} />;
                  })}
                </StyledTableCell>
                <StyledTableCell>
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.moreButton}
                    aria-owns={anchorEl ? `simple-menu-${row._id}` : undefined}
                    aria-haspopup="true"
                    onClick={this.openMenu(row)}
                  >
                    <FontAwesomeIcon icon={faEllipsisH} />
                  </Button>
                  <Menu
                    id={`simple-menu-${row._id}`}
                    anchorEl={anchorEl}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    getContentAnchorEl={null}
                    open={this.state.openMenuRowId === row._id}
                    onClose={this.closeMenu}
                  >
                    <MenuItem
                      className={classes.editMenu}
                      onClick={() => {
                        this.closeMenu();
                        this.props.onEditFreightForwarder(row);
                      }}
                    >
                      Edit Freight Forwarder
                    </MenuItem>
                    <MenuItem
                      className={classes.deleteMenu}
                      onClick={() => {
                        this.closeMenu();
                        this.props.onDeleteFreightForwarder(row);
                      }}
                    >
                      Delete Freight Forwarder
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        this.closeMenu();
                        this.props.onShowApiKey(row);
                      }}
                    >
                      Show API Key
                    </MenuItem>
                  </Menu>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              {totalItems > 0 && (
                <TablePagination
                  rowsPerPageOptions={[itemsPerPage]}
                  count={totalItems}
                  rowsPerPage={itemsPerPage}
                  page={currentPage}
                  classes={{ spacer: classes.spacer }}
                  backIconButtonProps={{
                    'aria-label': 'Previous Page',
                  }}
                  nextIconButtonProps={{
                    'aria-label': 'Next Page',
                  }}
                  onPageChange={onPageChange}
                />
              )}
            </TableRow>
          </TableFooter>
        </StyledTable>
      </div>
    );
  }
}

class FreightForwarderIndexPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      freightForwarders: [],
      itemsPerPage: 10,
      totalItems: 0,
    };
  }

  componentDidMount() {
    this.loadFreightForwarders();
  }

  componentWillUnmount() {}

  loadFreightForwarders(currentPage = 0) {
    this.setState({ loading: true });
    return this.props.firebase
      .freightForwarders(
        {},
        {
          itemsPerPage: this.state.itemsPerPage,
          currentPage: currentPage + 1,
          includeStats: true,
        }
      )
      .then((response) => {
        let { freightForwarders, totalItems } = response;
        this.setState((state) => {
          return {
            freightForwarders,
            currentPage,
            totalItems,
            loading: false,
          };
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  handlePageChange = (e, currentPage) => {
    this.loadFreightForwarders(currentPage);
  };

  goToFreightForwarder = (freightForwarder) => {
    this.props.history.push(`freight-forwarders/${freightForwarder._id}`);
  };

  editFreightForwarder = (freightForwarder) => {
    this.props.history.push(`freight-forwarders/${freightForwarder._id}`);
  };

  showApiKey = (freightForwarder) => {
    this.props.firebase.freightForwarderApiKey(freightForwarder._id).then((res) => {
      openSnackbar({
        message: `Please treat this API KEY securely as you would a password.\nAPI KEY: ${res.apiKey}`,
        variant: 'success',
        autoHideDuration: null,
      });
    });
  };

  deleteFreightForwarder = (freightForwarder) => {
    openConfirmDialog({
      title: 'Confirm Delete',
      message: `Are you sure you want to delete Freight Forwarder: ${freightForwarder.name}?`,
    }).then((res) => {
      if (res === 'OK') {
        this.props.firebase.freightForwarderDelete(freightForwarder).then(() => {
          this.setState((state) => {
            let freightForwarders = state.freightForwarders.filter((u) => u._id !== freightForwarder._id);
            return {
              freightForwarders,
            };
          });
        });
      }
    });
  };

  render() {
    const { classes } = this.props;
    const { freightForwarders, loading, currentPage, itemsPerPage, totalItems } = this.state;

    return (
      <Grid container spacing={3}>
        <Spinner visible={loading} />
        <Grid item xs={12}>
          <Typography variant="h1">Freight Forwarders</Typography>
        </Grid>
        <Grid item xs={12}>
          <Button
            component={Link}
            to={`/admin/freight-forwarders/new`}
            size="large"
            variant="outlined"
            color="secondary"
            className={classes.outlineButton}
          >
            <FontAwesomeIcon className={classes.leftIcon} icon={faPlus} />
            Add Freight Forwarder
          </Button>
        </Grid>
        <Grid item xs={12}>
          <FreightForwardersTable
            freightForwarders={freightForwarders}
            classes={classes}
            onPageChange={this.handlePageChange}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            totalItems={totalItems}
            onEditFreightForwarder={this.editFreightForwarder}
            onDeleteFreightForwarder={this.deleteFreightForwarder}
            onShowApiKey={this.showApiKey}
          />
        </Grid>
      </Grid>
    );
  }
}

const condition = (authUser) => authUser && authUser.roles && authUser.roles.includes(ROLES.ADMIN);

export default compose(
  withAuthorization(condition),
  withStyles(styles, { withTheme: true })
)(FreightForwarderIndexPage);
